export default __webpack_public_path__ + "static/media/X_Xaxim.e852b4fa.svg";